const map = {
	"./APP_DETAILS_API.svg": 73613,
	"./APP_STATUS_API.svg": 69969,
	"./APP_STATUS_API_PUSH.svg": 10560,
	"./APP_SUBMISSION_API.svg": 25659,
	"./BENEFIT_DETAILS_API.svg": 45325,
	"./BOB_API.svg": 18918,
	"./BROKER_NEWS_FEED_API.svg": 48825,
	"./CMPY_BENEFIT_DTL_API.svg": 64659,
	"./COMM_API.svg": 6799,
	"./COVG_DOC_API.svg": 91719,
	"./DOC_UPLOAD_API.svg": 63797,
	"./GENC_UPLOAD_API.svg": 33808,
	"./GEN_UPLOAD_API.svg": 80065,
	"./GRP_STRUCT_API.svg": 71228,
	"./Group 28.svg": 59535,
	"./IVR_USER_INFO_API.svg": 703,
	"./MBR_ENROLL_API.svg": 899,
	"./MBR_MNTNC_API.svg": 72753,
	"./MED_ELIGIBILITY_API.svg": 64823,
	"./OPTY_MGMT_API.svg": 95795,
	"./QUOTE_ACTIVITY_API.svg": 61175,
	"./QUOTE_API.svg": 27235,
	"./RENEWAL_API.svg": 96607,
	"./RENEW_PKG_API.svg": 86239
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89578;